import React, { ReactNode, Dispatch, SetStateAction, useState } from 'react';
import List from '@mui/material/List';
import { Autocomplete, TextField } from '@mui/material';
import { IThanaList } from 'src/basic-rest/types';
import { AddressLoading, AddressNotFound } from './utils';
import { IGetID } from './Address';
import { useFetchThanaData } from 'src/basic-rest/useFetchAddressData';
import { Box } from '@mui/system';

type IProps = {
  checked: IGetID;
  setChecked: Dispatch<SetStateAction<IGetID>>;
};

function FilterThanaList({ checked, setChecked }: IProps) {
  const [open, setOpen] = useState(false);
  const {
    data: thanaData,
    fetchThanaData,
    loading,
    setData,
  } = useFetchThanaData();

  React.useEffect(() => {
    if (checked?.division) {
      fetchThanaData({
        district_id: checked?.district?.district_id,
        division_id: checked?.division?.division_id,
      });
    } else {
      fetchThanaData();
    }
  }, [checked.district, checked.division]);

  let content: ReactNode;
  if (loading) {
    content = <AddressLoading />;
  }
  if (!loading && thanaData.length === 0) {
    content = <AddressNotFound />;
  }

  if (thanaData.length > 0 && !loading) {
    content = (
      <Autocomplete
        size='small'
        getOptionLabel={(option: IThanaList) => option.thana_name}
        id='combo-box-demo'
        options={thanaData}
        renderOption={(params: any, option: IThanaList) => (
          <Box component='li' {...params}>
            {option.thana_name}
          </Box>
        )}
        renderInput={(params) => (
          <TextField {...params} label='Select thana' variant='outlined' />
        )}
        onChange={(_event, value: IThanaList) => {
          setChecked({ ...checked, thana: value, area: null });
        }}
      />
    );
  }

  return (
    <>
      <List
        sx={{
          width: '100%',
        }}
      >
        {content}
      </List>
    </>
  );
}

export default FilterThanaList;
